import { useState, useEffect } from 'react'

export function useHasMergeTags(content) {
    const [result, setResult] = useState(false)

    useEffect(() => {
        if (!content) return setResult(false)
        setResult(content.replace('{{__OPTOUT}}', '').includes('{{'))
    }, [content])

    return result
}